import { Suspense } from "react";
import { RouterProvider, createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";

import GlobalErrorBoundary from "../page/GlobalErrorBoundary";

import MediaConfig from "../config/MediaConfig";
import MenuConfig from "../config/MenuConfig";
import BookmarkConfig from "../config/BookmarkConfig";
import ApmConfig from "../config/ApmConfig";

import DevAccess from "../context/DevContext";
import ResourceContext from "../context/ResourceContext";
import LabelContext from "../context/LabelContext";
import AppContext from "../context/AppContext";
import PageContext from "../context/PageContext";
import LayoutProvider from "../layout";

import { Main } from "@/tz/go/egaz/osci/Main";

import SampleMain from "@/comn/sample/smpl-Main";
import { ComnMain } from "@/comn/comn/comn-Main";

import PortalMain from "../page/PortalMain";
import Login from "../page/Login";

//401
import Unauthorized from "../page/Unauthorized";
// 403
import Forbidden from "../page/Forbidden";
// 404
import NotFound from "../page/not-found";
// 405
import NotAllowed from "../page/not-allowed";
// 406
import NotAcceptable from "../page/not-acceptable";
// 500
import InternalServerError from "../page/internal-server-error";

import FindId from "../page/FindId";
import FindPassword from "../page/FindPassword";
import ChangePassword from "../page/ChangePassword";
import ReactivateAccount from "../page/ReactivateAccount";
import RenewalAccount from "@/comn/features/page/RenewalAccount";

import CommonModal from "@/comn/components/_/CommonModal";
import CommonToast from "@/comn/components/_/CommonToast";
import LoadingIndicator from "@/comn/components/_/LoadingIndicator";

import { DevRoutes } from "@/comn/features/router/Dev_Routes";

import Test from "@/comn/sample/Test/Test";

import { OsciPdfViewer } from "@/tz/go/egaz/osci/comn/rprt/OsciPdfViewer";

import { TimeoutConfig } from "../config/TimeoutConfig";
import { GlobalFeedbackModal } from "../layout/Reveiw/GlobalFeedbackModal";

// == 포털 공통 기능 관리를 위한 라우터 설정 Start ==
import { PtlRouter } from "@/tz/go/egaz/osci/ptl/router/PtlRouter";
import { MyPageRouter } from "@/tz/go/egaz/osci/ptl/router/MyPageRouter";
import { UsrRouter } from "@/tz/go/egaz/osci/ptl/router/UsrRouter";
import { ClstportRouter } from "@/tz/go/egaz/osci/ptl/router/ClstportRouter";
import { ComnMdleRouter } from "@/tz/go/egaz/osci/ptl/router/ComnMdleRouter";
import { CtraRouter } from "@/tz/go/egaz/osci/ptl/router/CtraRouter";
import { InfoRouter } from "@/tz/go/egaz/osci/ptl/router/InfoRouter";
import { ElctdocRouter } from "@/tz/go/egaz/osci/ptl/router/ElctdocRouter";
import { BtchRouter } from "@/tz/go/egaz/osci/ptl/router/BtchRouter";
import { OsciStstclRouter } from "@/tz/go/egaz/osci/ststcl/router/OsciStstclRouter";
import FindAccount from "../page/FindAccount";
// == 포털 공통 기능 관리를 위한 라우터 설정 End ==

export const routes: any = [...DevRoutes];

const createRoutes = () => {
    const routes = [
        { path: "/comn/smpl/*", element: <SampleMain /> },
        { path: "/comn/*", element: <ComnMain /> },
        { path: "/findId", element: <FindAccount /> },
        { path: "/findPassword", element: <FindPassword /> },
        { path: "/changePassword", element: <ChangePassword /> },
        { path: "/reactivateAccount", element: <ReactivateAccount /> },
        { path: "/renewalAccount", element: <RenewalAccount /> },
        { path: process.env.REACT_APP_BASE + "/401", element: <Unauthorized /> },
        { path: process.env.REACT_APP_BASE + "/403", element: <Forbidden /> },
        { path: process.env.REACT_APP_BASE + "/404", element: <NotFound /> },
        { path: process.env.REACT_APP_BASE + "/405", element: <NotAllowed /> },
        { path: process.env.REACT_APP_BASE + "/406", element: <NotAcceptable /> },
        { path: process.env.REACT_APP_BASE + "/500", element: <InternalServerError /> },
        { path: process.env.REACT_APP_BASE, element: <PortalMain /> },
        { path: "/ptlo", element: <PortalMain /> },
        { path: "/osci", element: <PortalMain /> },
        // == 포털 공통 기능 Start ==
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/ptl/*", element: <PtlRouter /> }, // 포털 관리
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/mypg/*", element: <MyPageRouter /> }, // My Page
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/mypage/*", element: <MyPageRouter /> },
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/usr/*", element: <UsrRouter /> }, // 사용자
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/clntsport/*", element: <ClstportRouter /> }, // 매뉴얼
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/comnmdle/*", element: <ComnMdleRouter /> }, // 공통 모듈
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/ctra/*", element: <CtraRouter /> }, // 기준 정보
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/info/*", element: <InfoRouter /> }, // 정보
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/intf/*", element: <ElctdocRouter /> }, // 전자 문서 (인터페이스)
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/ststcl/*", element: <OsciStstclRouter /> }, // 통계
        { path: "/" + process.env.REACT_APP_BASE_PTL_COMN + "/btch/*", element: <BtchRouter /> }, // 배치
        // == 포털 공통 기능 End ==
        { path: "*", element: <Main /> },
    ];

    if (process.env.NODE_ENV === "development") {
        routes.push({ path: "/test/*", element: <Test /> });
    }

    return routes;
};

const router = createBrowserRouter([
    {
        // Pre-configuration
        element: (
            <>
                <LabelContext.Provider>
                    <ResourceContext.Provider>
                        <MediaConfig />
                        <CommonToast />
                        <LoadingIndicator />
                        <div id="datepicker" style={{ zIndex: 10000, position: "absolute" }} />
                        <Outlet />
                    </ResourceContext.Provider>
                </LabelContext.Provider>
            </>
        ),
        // Global Error Boundary
        errorElement: <GlobalErrorBoundary />,
        children: [
            { path: "/login", element: <Login /> },
            { path: "/rprt/pdfviewer/:origCfrmUuid", element: <OsciPdfViewer /> },
            {
                element: (
                    <AppContext.Provider>
                        <PageContext.Provider>
                            {/* <DevAccess> */}
                            {/* <LabelContext.Suspenser> */}
                            {/* <LabelContext.Fetcher> */}
                            <LayoutProvider>
                                <AppContext.Suspenser>
                                    <AppContext.Fetcher>
                                        <ApmConfig />

                                        {/* 2025-04-10 TRA */}
                                        <TimeoutConfig />
                                        <GlobalFeedbackModal />
                                        <MenuConfig />
                                        <BookmarkConfig />

                                        <PageContext.Suspenser>
                                            <PageContext.Fetcher>
                                                <ScrollRestoration />
                                                <Suspense>
                                                    <Outlet />
                                                </Suspense>
                                                <CommonModal />
                                            </PageContext.Fetcher>
                                        </PageContext.Suspenser>
                                    </AppContext.Fetcher>
                                </AppContext.Suspenser>
                            </LayoutProvider>
                            {/* </LabelContext.Fetcher> */}
                            {/* </LabelContext.Suspenser> */}
                            {/* </DevAccess> */}
                        </PageContext.Provider>
                    </AppContext.Provider>
                ),
                children: createRoutes(),
            },
        ],
    },
]);

const Router = () => {
    return <RouterProvider router={router} />;
};

export default Router;
